"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _executionListener = _interopRequireDefault(require("./property/executionListener"));
var _taskListener = _interopRequireDefault(require("./property/taskListener"));
var _multiInstance = _interopRequireDefault(require("./property/multiInstance"));
var _parseElement = require("@/libs/flowable/common/parseElement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    executionListenerDialog: _executionListener.default,
    taskListenerDialog: _taskListener.default,
    multiInstanceDialog: _multiInstance.default
  },
  mixins: [_mixinPanel.default],
  props: {
    users: {
      type: Array,
      required: true
    },
    groups: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      userTypeOption: [{
        label: '指定人员',
        value: 'assignee'
      }, {
        label: '候选人员',
        value: 'candidateUsers'
      }, {
        label: '候选组',
        value: 'candidateGroups'
      }],
      dialogName: '',
      executionListenerLength: 0,
      taskListenerLength: 0,
      hasMultiInstance: false,
      formData: {}
    };
  },
  computed: {
    formConfig: function formConfig() {
      var _this = this;
      return {
        inline: false,
        item: [{
          xType: 'input',
          name: 'id',
          label: '节点 id',
          rules: [{
            required: true,
            message: 'Id 不能为空'
          }]
        }, {
          xType: 'input',
          name: 'name',
          label: '节点名称'
        }, {
          xType: 'input',
          name: 'documentation',
          label: '节点描述'
        }, {
          xType: 'slot',
          name: 'executionListener',
          label: '执行监听器'
        }, {
          xType: 'slot',
          name: 'taskListener',
          label: '任务监听器',
          show: !!_this.showConfig.taskListener
        }, {
          xType: 'select',
          name: 'userType',
          label: '人员类型',
          dic: _this.userTypeOption,
          show: !!_this.showConfig.userType
        }, {
          xType: 'select',
          name: 'assignee',
          label: '指定人员',
          allowCreate: true,
          filterable: true,
          dic: {
            data: _this.users,
            label: 'name',
            value: 'id'
          },
          show: !!_this.showConfig.assignee && _this.formData.userType === 'assignee'
        }, {
          xType: 'select',
          name: 'candidateUsers',
          label: '候选人员',
          multiple: true,
          allowCreate: true,
          filterable: true,
          dic: {
            data: _this.users,
            label: 'name',
            value: 'id'
          },
          show: !!_this.showConfig.candidateUsers && _this.formData.userType === 'candidateUsers'
        }, {
          xType: 'select',
          name: 'candidateGroups',
          label: '候选组',
          multiple: true,
          allowCreate: true,
          filterable: true,
          dic: {
            data: _this.groups,
            label: 'name',
            value: 'id'
          },
          show: !!_this.showConfig.candidateGroups && _this.formData.userType === 'candidateGroups'
        }, {
          xType: 'slot',
          name: 'multiInstance',
          label: '多实例'
        }, {
          xType: 'switch',
          name: 'async',
          label: '异步',
          activeText: '是',
          inactiveText: '否',
          show: !!_this.showConfig.async
        }, {
          xType: 'input',
          name: 'priority',
          label: '优先级',
          show: !!_this.showConfig.priority
        }, {
          xType: 'input',
          name: 'formKey',
          label: '表单标识key',
          show: !!_this.showConfig.formKey
        }, {
          xType: 'input',
          name: 'skipExpression',
          label: '跳过表达式',
          show: !!_this.showConfig.skipExpression
        }, {
          xType: 'switch',
          name: 'isForCompensation',
          label: '是否为补偿',
          activeText: '是',
          inactiveText: '否',
          show: !!_this.showConfig.isForCompensation
        }, {
          xType: 'switch',
          name: 'triggerable',
          label: '服务任务可触发',
          activeText: '是',
          inactiveText: '否',
          show: !!_this.showConfig.triggerable
        }, {
          xType: 'switch',
          name: 'autoStoreVariables',
          label: '自动存储变量',
          activeText: '是',
          inactiveText: '否',
          show: !!_this.showConfig.autoStoreVariables
        }, {
          xType: 'input',
          name: 'ruleVariablesInput',
          label: '输入变量',
          show: !!_this.showConfig.ruleVariablesInput
        }, {
          xType: 'input',
          name: 'rules',
          label: '规则',
          show: !!_this.showConfig.rules
        }, {
          xType: 'input',
          name: 'resultVariable',
          label: '结果变量',
          show: !!_this.showConfig.resultVariable
        }, {
          xType: 'switch',
          name: 'exclude',
          label: '排除',
          activeText: '是',
          inactiveText: '否',
          show: !!_this.showConfig.exclude
        }, {
          xType: 'input',
          name: 'class',
          label: '类',
          show: !!_this.showConfig.class
        }, {
          xType: 'datePicker',
          type: 'datetime',
          name: 'dueDate',
          label: '到期时间',
          show: !!_this.showConfig.dueDate
        }]
      };
    }
  },
  watch: {
    'formData.userType': function formDataUserType(val, oldVal) {
      var _this2 = this;
      if (oldVal) {
        var types = ['assignee', 'candidateUsers', 'candidateGroups'];
        types.forEach(function (type) {
          delete _this2.element.businessObject.$attrs["flowable:".concat(type)];
          delete _this2.formData[type];
        });
      }
    },
    'formData.assignee': function formDataAssignee(val) {
      if (this.formData.userType !== 'assignee') {
        delete this.element.businessObject.$attrs["flowable:assignee"];
        return;
      }
      this.updateProperties({
        'flowable:assignee': val
      });
    },
    'formData.candidateUsers': function formDataCandidateUsers(val) {
      if (this.formData.userType !== 'candidateUsers') {
        delete this.element.businessObject.$attrs["flowable:candidateUsers"];
        return;
      }
      this.updateProperties({
        'flowable:candidateUsers': val.join(',')
      });
    },
    'formData.candidateGroups': function formDataCandidateGroups(val) {
      if (this.formData.userType !== 'candidateGroups') {
        delete this.element.businessObject.$attrs["flowable:candidateGroups"];
        return;
      }
      this.updateProperties({
        'flowable:candidateGroups': val.join(',')
      });
    },
    'formData.async': function formDataAsync(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:async': true
      });
    },
    'formData.dueDate': function formDataDueDate(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:dueDate': val
      });
    },
    'formData.formKey': function formDataFormKey(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:formKey': val
      });
    },
    'formData.priority': function formDataPriority(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:priority': val
      });
    },
    'formData.skipExpression': function formDataSkipExpression(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:skipExpression': val
      });
    },
    'formData.isForCompensation': function formDataIsForCompensation(val) {
      if (val === '') val = null;
      this.updateProperties({
        'isForCompensation': val
      });
    },
    'formData.triggerable': function formDataTriggerable(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:triggerable': val
      });
    },
    'formData.class': function formDataClass(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:class': val
      });
    },
    'formData.autoStoreVariables': function formDataAutoStoreVariables(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:autoStoreVariables': val
      });
    },
    'formData.exclude': function formDataExclude(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:exclude': val
      });
    },
    'formData.ruleVariablesInput': function formDataRuleVariablesInput(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:ruleVariablesInput': val
      });
    },
    'formData.rules': function formDataRules(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:rules': val
      });
    },
    'formData.resultVariable': function formDataResultVariable(val) {
      if (val === '') val = null;
      this.updateProperties({
        'flowable:resultVariable': val
      });
    }
  },
  created: function created() {
    var cache = (0, _parseElement.commonParse)(this.element);
    cache = (0, _parseElement.userTaskParse)(cache);
    this.formData = cache;
    this.computedExecutionListenerLength();
    this.computedTaskListenerLength();
    this.computedHasMultiInstance();
  },
  methods: {
    computedExecutionListenerLength: function computedExecutionListenerLength() {
      var ele = this.element.businessObject.extensionElements;
      if (ele !== undefined && ele !== null) {
        var obj = ele.values.filter(function (item) {
          return item.$type === 'flowable:ExecutionListener';
        });
        if (obj !== undefined && obj !== null) {
          this.executionListenerLength = obj.length;
        } else {
          this.executionListenerLength = 0;
        }
      }
    },
    computedTaskListenerLength: function computedTaskListenerLength() {
      var ele = this.element.businessObject.extensionElements;
      if (ele !== undefined && ele !== null) {
        var obj = ele.values.filter(function (item) {
          return item.$type === 'flowable:TaskListener';
        });
        if (obj !== undefined && obj !== null) {
          this.taskListenerLength = obj.length;
        } else {
          this.taskListenerLength = 0;
        }
      }
    },
    computedHasMultiInstance: function computedHasMultiInstance() {
      if (this.element.businessObject.loopCharacteristics) {
        this.hasMultiInstance = true;
      } else {
        this.hasMultiInstance = false;
      }
    },
    finishExecutionListener: function finishExecutionListener() {
      if (this.dialogName === 'executionListenerDialog') {
        this.computedExecutionListenerLength();
      }
      this.dialogName = '';
    },
    finishTaskListener: function finishTaskListener() {
      if (this.dialogName === 'taskListenerDialog') {
        this.computedTaskListenerLength();
      }
      this.dialogName = '';
    },
    finishMultiInstance: function finishMultiInstance() {
      if (this.dialogName === 'multiInstanceDialog') {
        this.computedHasMultiInstance();
      }
      this.dialogName = '';
    }
  }
};